import React from 'react';
import Box from 'react-layout-components';

import FetchState from '../../utils/FetchState';
import CircularProgress, { Props as CircularProgressProps } from './CircularProgress';

export interface Props {
  fetchStates: (FetchState | undefined)[];
  className?: string;
  children?: React.ReactNode;
  circularProgressProps?: Partial<CircularProgressProps>;
  showOnNotFound?: () => JSX.Element;
}

function isNotFetched(fetchState: FetchState): boolean {
  return !fetchState || !fetchState.fetchedAtLeastOnce;
}

function notFound(fetchState: FetchState): boolean {
  return fetchState && !fetchState.isFetching && !fetchState.fetchRequired && !fetchState.fetchedAtLeastOnce;
}

function FetchStateCircularProgress(props: Props) {
  const { fetchStates, className, circularProgressProps, children, showOnNotFound } = props;
  if (showOnNotFound && fetchStates.some(notFound)) {
    return showOnNotFound();
  }
  if (fetchStates.some(isNotFetched)) {
    return (
      <Box fit center className={className}>
        <CircularProgress {...circularProgressProps} />
      </Box>
    );
  }
  return <>{children}</>;
}

export default FetchStateCircularProgress;
